import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddEditClientComponent } from './components/add-edit-client/add-edit-client.component';
import { AddEditIncidentTypeComponent } from './components/add-edit-incident-type/add-edit-incident-type.component';

import { AddEditMonitoringCompanyComponent } from './components/add-edit-monitoring-company/add-edit-monitoring-company.component';
import { AddEditResponseTypeComponent } from './components/add-edit-response-type/add-edit-response-type.component';

import { AddEditServiceTypeComponent } from './components/add-edit-service-type/add-edit-service-type.component';
import { AddEditSiteComponent } from './components/add-edit-site/add-edit-site.component';
import { AddressLookupComponent } from './components/address-lookup/address-lookup.component';
import { AutoCompleteComponent } from './components/auto-complete/auto-complete.component';
import { BarChartComponent } from './components/bar-chart/bar-chart.component';
import { CardListComponent } from './components/card-list/card-list.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { ClientSiteContactsComponent } from './components/client-site-contacts/client-site-contacts.component';
import { CompanyLicencePromptComponent } from './components/company-licence-prompt/company-licence-prompt.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { ContactComponent } from './components/contact/contact.component';
import { DatetimePickerComponent } from './components/datetime-picker/datetime-picker.component';
import { DragMapComponent } from './components/drag-map/drag-map.component';
import { EventSchedulerComponent } from './components/event-scheduler/event-scheduler.component';
import { GettingStartedComponent } from './components/getting-started/getting-started.component';
import { GtTableComponent } from './components/gt-table/gt-table.component';
import { AddEditIdentificationComponent } from './components/identification/add-edit-identification/add-edit-identification.component';
import { Identification } from './components/identification/identification';
import { ImageCaptureComponent } from './components/image-capture/image-capture.component';
import { MediaPreviewComponent } from './components/media-preview/media-preview.component';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { InfiniteListComponent } from './components/infinite-list/infinite-list.component';
import { InputFieldComponent } from './components/input-field/input-field.component';
import { MapLeafletComponent } from './components/map-leaflet/map-leaflet.component';
import { MapPinsViewComponent } from './components/map-pins-view/map-pins-view.component';
import { ModalDialogueService } from './components/modal-dialogue/modal-dialogue.service';
import { PaginationControlComponent } from './components/pagination-control/pagination-control.component';
import { PrompterComponent } from './components/prompter/prompter.component';
import { ScanQrNfcComponent } from './components/scan-qr-nfc/scan-qr-nfc.component';
import { SchedulerComponent } from './components/scheduler/scheduler.component';
import { ScreenshotGuideComponent } from './components/screenshot-guide/screenshot-guide.component';
import { SelectedEventDetailComponent } from './components/selected-event-detail/selected-event-detail.component';
import { SiteKeysComponent } from './components/site-keys/site-keys.component';
import { SplashScreenComponent } from './components/splash-screen/splash-screen.component';
import { UpdatedEventDetailComponent } from './components/updated-event-detail/updated-event-detail.component';
import { UploadTypeComponent } from './components/upload-type/upload-type.component';
import { ViewUserDetailComponent } from './components/view-user-detail/view-user-detail.component';
import { WhatsNewComponent } from './components/whats-new/whats-new.component';
import { PopoverDirective } from './directives/popover.directive';
import { CustomDatePipe } from './pipes/custom-date.pipe';
import { MiscPipe } from './pipes/misc.pipe';
import { DataCheckService } from './services/data-check.service';
import { DynamicScriptLoadService } from './services/dynamic-script-load.service';
import { LoadingSpinnerService } from './services/loading-spinner.service';
import { StackedBarChartComponent } from './components/stacked-bar-chart/stacked-bar-chart.component';
import { UserTrailComponent } from './components/user-trail/user-trail.component';
import { LeafletTrailMapComponent } from './components/user-trail/leaflet-trail-map/leaflet-trail-map.component';
import { GtCustomTableComponent } from './components/gt-custom-table/gt-custom-table.component';
import { AddScheduledReportsComponent } from './components/add-scheduled-reports/add-scheduled-reports.component';
import { UserLoginComponent } from './components/user-login/user-login.component';
import { ModifyLetterheadLogoComponent } from './components/modify-letterhead-logo/modify-letterhead-logo.component';
import { MultipleAccountsComponent } from './components/multiple-accounts/multiple-accounts.component';
import { QueuedEventsComponent } from './components/queued-events/queued-events.component';
import { AddCheckpointRouteComponent } from './components/add-checkpoint-route/add-checkpoint-route.component';

import { UserLiveDataComponent } from './components/user-live-data/user-live-data.component';
import { UserLiveJobsComponent } from './components/user-live-jobs/user-live-jobs.component';
import { ClockInOutComponent } from './components/clock-in-out/clock-in-out.component';
import { ScanCheckpointComponent } from './components/scan-checkpoint/scan-checkpoint.component';
import { ConfigureScanMenuComponent } from './components/configure-scan-menu/configure-scan-menu.component';
import { DataFilterComponent } from './components/data-filter/data-filter.component';
import { MobileFormInputDataComponent } from './components/mobile-form-input-data/mobile-form-input-data.component';
import { ChangeScheduleComponent } from './components/change-schedule/change-schedule.component';
import { ReservedUserBillingDetailsComponent } from './components/reserved-user-billing-details/reserved-user-billing-details.component';
import { SitePreferredUsersComponent } from './components/site-preferred-users/site-preferred-users.component';
import { SelectUsersComponent } from './components/select-users/select-users.component';
import { AppChecksComponent } from './components/app-checks/app-checks.component';
import { GtTooltipDirective } from './directives/gt-tooltip.directive';
import { SelectSubBillerComponent } from './components/select-sub-biller/select-sub-biller.component';
import { SelectMonitoringCompanyComponent } from './components/select-monitoring-company/select-monitoring-company.component';
import { RequestLeaveComponent } from './components/request-leave/request-leave.component';
import { GtCalendarComponent } from './components/gt-calendar/gt-calendar.component';
import { UserLookupComponent } from './components/user-lookup/user-lookup.component';
import { PreSafetyPromptsComponent } from './components/pre-safety-prompts/pre-safety-prompts.component';
import { AddMobileFormComponent } from './components/add-mobile-form/add-mobile-form.component';
@NgModule({
  declarations: [
    MapPinsViewComponent,
    CardListComponent,
    GtTableComponent,
    PaginationControlComponent,
    ScanQrNfcComponent,
    ConfirmDialogComponent,
    MapLeafletComponent,
    AddEditSiteComponent,
    AddEditClientComponent,
    DragMapComponent,
    SchedulerComponent,
    FileUploadComponent,
    UploadTypeComponent,
    AddEditMonitoringCompanyComponent,
    ContactComponent,
    AddEditResponseTypeComponent,
    PrompterComponent,
    DatetimePickerComponent,
    EventSchedulerComponent,
    SelectedEventDetailComponent,
    MiscPipe,
    ChangePasswordComponent,
    ScreenshotGuideComponent,
    AutoCompleteComponent,
    InfiniteListComponent,
    BarChartComponent,
    MediaPreviewComponent,
    ClientSiteContactsComponent,
    WhatsNewComponent,
    AddEditIncidentTypeComponent,
    CustomDatePipe,
    AddressLookupComponent,
    AddEditServiceTypeComponent,
    InputFieldComponent,
    UpdatedEventDetailComponent,
    SiteKeysComponent,
    ImageCaptureComponent,
    ViewUserDetailComponent,
    PopoverDirective,
    AddEditIdentificationComponent,
    Identification,
    CompanyLicencePromptComponent,
    SplashScreenComponent,
    GettingStartedComponent,
    StackedBarChartComponent,
    UserTrailComponent,
    LeafletTrailMapComponent,
    GtCustomTableComponent,
    AddScheduledReportsComponent,
    UserLoginComponent,
    ModifyLetterheadLogoComponent,
    MultipleAccountsComponent,
    QueuedEventsComponent,
    AddCheckpointRouteComponent,
    UserLiveDataComponent,
    UserLiveJobsComponent,
    ClockInOutComponent,
    ScanCheckpointComponent,
    ConfigureScanMenuComponent,
    DataFilterComponent,
    MobileFormInputDataComponent,
    ChangeScheduleComponent,
    ReservedUserBillingDetailsComponent,
    SitePreferredUsersComponent,
    SelectUsersComponent,
    AppChecksComponent,
    GtTooltipDirective,
    SelectSubBillerComponent,
    SelectMonitoringCompanyComponent,
    RequestLeaveComponent,
    GtCalendarComponent,
    UserLookupComponent,
    PreSafetyPromptsComponent,
    AddMobileFormComponent,
  ],
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  exports: [
    MapPinsViewComponent,
    CardListComponent,
    GtTableComponent,
    PaginationControlComponent,
    ScanQrNfcComponent,
    MapLeafletComponent,
    AddEditSiteComponent,
    ConfirmDialogComponent,
    AddEditClientComponent,
    DragMapComponent,
    FileUploadComponent,
    UploadTypeComponent,
    AddEditMonitoringCompanyComponent,
    ContactComponent,
    SchedulerComponent,
    SelectedEventDetailComponent,
    MiscPipe,
    PrompterComponent,
    AutoCompleteComponent,
    InfiniteListComponent,
    BarChartComponent,
    MediaPreviewComponent,
    ClientSiteContactsComponent,
    CustomDatePipe,
    AddressLookupComponent,
    InputFieldComponent,
    UpdatedEventDetailComponent,
    SiteKeysComponent,
    ImageCaptureComponent,
    ViewUserDetailComponent,
    PopoverDirective,
    Identification,
    AddEditIdentificationComponent,
    CompanyLicencePromptComponent,
    SplashScreenComponent,
    GettingStartedComponent,
    StackedBarChartComponent,
    UserTrailComponent,
    GtCustomTableComponent,
    UserLoginComponent,
    MultipleAccountsComponent,
    QueuedEventsComponent,
    AddCheckpointRouteComponent,
    UserLiveDataComponent,
    UserLiveJobsComponent,
    ClockInOutComponent,
    ConfigureScanMenuComponent,
    ScanCheckpointComponent,
    DataFilterComponent,
    MobileFormInputDataComponent,
    ChangeScheduleComponent,
    ReservedUserBillingDetailsComponent,
    SitePreferredUsersComponent,
    SelectUsersComponent,
    AppChecksComponent,
    GtTooltipDirective,
    SelectSubBillerComponent,
    RequestLeaveComponent,
    GtCalendarComponent,
    UserLookupComponent,
    PreSafetyPromptsComponent,
  ],
})
export class SharedModule {
  static forRoot() {
    return {
      NgModule: SharedModule,
      providers: [
        DataCheckService,
        DynamicScriptLoadService,
        LoadingSpinnerService,
        ModalDialogueService,
      ],
    };
  }
}
